import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { updateFlowStatus } from 'src/components/Subheader/Subheader.slice';
import { fetchProductDetailsGridData, fetchProductDetailsMacroData } from './ProductDetails.slice';
import { inputIsNotNullOrUndefined, maybeGetComponentProps } from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, ProductDetailsComponent } from 'configuration-schemas/confdefnComponents';
import { DataApi } from 'configuration-schemas/confdefnView';
import {
  ExtraPivotOptions,
  organizeListDataOptions,
} from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { LEVEL_PROD_ROOT } from 'src/utils/Domain/Constants';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { setActivePage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';

export const productDetailsLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      updateFlowStatus.type,
      receiveScopeConfig.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
    ),
    map(() => maybeGetComponentProps<ProductDetailsComponent>(state$.value, ConfDefnComponentType.productDetails)),
    filter(inputIsNotNullOrUndefined),
    mergeMap(({ defns }) => {
      const [gridModelDefn, macroModelDefn] = defns.models;
      const flowStatus = state$.value.subheader.flowStatus.join(',');

      // TODO: move this to config when ready
      const macroDataApi: DataApi = {
        defnId: macroModelDefn,
        isListData: true,
        params: {
          aggBy: LEVEL_PROD_ROOT,
        },
      };

      const options: ExtraPivotOptions = { flowStatus };
      const finalMacroOptions = organizeListDataOptions(options, macroDataApi);

      return of(
        fetchProductDetailsMacroData(macroModelDefn, finalMacroOptions),
        fetchProductDetailsGridData(gridModelDefn, options),
      );
    }),
  );
};
